module.exports = __webpack_public_path__ + "static/media/la-veranda.a78cbeb5.jpg";